import { Injectable, inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import {
  GET_ALL_FACILITIES,
  UPDATE_FACILITY_ENERGY_CREDITS_ENABLED,
} from '../queries/energy-credits-admin.queries';
import { FacilityEnergyCredit } from '../models/facility-energy-credits.model';
import { MutationResult, UpdateResult } from 'src/app/shared/graph-queries/types';

@Injectable({
  providedIn: 'root',
})
export class EnergyCreditsAdminService {
  private apollo = inject(Apollo);

  getFacilities(): Observable<FacilityEnergyCredit[]> {
    return this.apollo
      .query<{ GetAllFacilities: FacilityEnergyCredit[] }>({
        query: GET_ALL_FACILITIES,
        fetchPolicy: 'no-cache',
      })
      .pipe(map((res) => res.data?.GetAllFacilities ?? []));
  }

  setEnergyCreditsEnabled(
    facilityId: string,
    isEnabled: boolean,
  ): Observable<MutationResult<{ UpdateFacilityEnergyCreditsEnabled: UpdateResult }>> {
    return this.apollo.mutate<{ UpdateFacilityEnergyCreditsEnabled: UpdateResult }>({
      mutation: UPDATE_FACILITY_ENERGY_CREDITS_ENABLED,
      variables: { id: facilityId, payload: String(isEnabled) },
      fetchPolicy: 'no-cache',
    });
  }
}
